import React, { Fragment } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import { ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Link } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import { Avatar } from 'antd';
import Icon from '@mdi/react';
import { mdiPin, mdiPinOff } from '@mdi/js';

import {
    addToPinnedAsset, removeFromPinnedAsset,
    setDetailView, removeDetailView, detailViewSelector,
    selectVehicleById
} from '../../features/assets/assetsSlice';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: useTheme().spacing(1),
        },
    },
    small: {
        width: useTheme().spacing(3),
        height: useTheme().spacing(3),
    },
    inline: {
        display: 'inline',
    },
    title: {
        flexGrow: 1,
    },
    toolbar: {

        justifyContent: 'end'
    },
    active: {
        backgroundColor: 'LightYellow'
    },
    inactive: {
        backgroundColor: 'White'
    }

}));

const AssetListItem = ({ assetId, pinned }) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const { vehicleDevice, coreData, statusMeta, dataSanity } = assetData;
    const detailView = useSelector(detailViewSelector);
    let speedtext = " ";
    let datetext = '';
    if (coreData && statusMeta) {
        if (statusMeta.locage >= 0 && statusMeta.locage < 5) {
            if (assetData.coreData.speed > 0) {
                speedtext += `  ( ${assetData.coreData.speed} Km/h )`;
            }
        }
        datetext = dataSanity ? moment(coreData.dt_server).format('D MMM YY h:mm:ss a') : null;
    }
    if (vehicleDevice.reg === "DN09 E 2190") {
        //console.log("Meta", vehicleDevice.regn, statusMeta.hbtage);
    }
    //console.log("AssetItem rendered");

    const togglePinned = () => {
        if (pinned) {
            //console.log("To unpin", assetId);
            dispatch(removeFromPinnedAsset(assetId))
        } else {
            //console.log("To Pin", assetId);
            if (coreData) {
                dispatch(addToPinnedAsset(assetId));
            }

        }
    }

    const toggleDetailView = () => {
        if (statusMeta.status !== 'No Data') {
            if (assetId === detailView) {
                dispatch(removeDetailView());
            } else {
                dispatch(setDetailView(assetId))
            }
        }
    }

    return (

        <ListItem
            className={assetId === detailView ? classes.active : classes.inactive}
        >
            <ListItemAvatar>
                <Avatar style={{ backgroundColor: 'white' }}>
                    <img alt="a" src={`/assets/markers/def30/${vehicleDevice.icon}`} />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    <Fragment>
                        <Link href="#" onClick={toggleDetailView}>
                            <Typography variant="subtitle2" className={classes.inline} color='textPrimary'>
                                <span>
                                    <b>
                                        {vehicleDevice.regn}
                                    </b>
                                </span>
                            </Typography>
                        </Link>

                        <Typography variant="caption" className={classes.inline}><span>
                            {speedtext}
                        </span></Typography>
                    </Fragment>
                }
                secondary={<Typography variant="caption" className={classes.inline}>{datetext}</Typography>}
            />
            <ListItemSecondaryAction>

                <Typography variant="subtitle2" className={classes.inline}>
                    <span style={{ color: statusMeta.colortext }}> {` ${statusMeta.status} `}</span>
                </Typography>

                <Checkbox
                    icon={
                        <Icon
                            path={mdiPinOff}
                            title="Live Map"
                            size={0.7}
                            color="Grey"
                        />
                    }
                    checkedIcon={
                        <Icon
                            path={mdiPin}
                            title="Live Map"
                            size={0.7}
                            color="SlateBlue"
                        />
                    }
                    name="pinned"
                    label={" "}
                    checked={pinned}
                    onChange={togglePinned}
                />



            </ListItemSecondaryAction>

        </ListItem>


    );
}

export default React.memo(AssetListItem);

/*
<Checkbox
                    icon={
                        <Icon
                            path={mdiMapMarkerOff}
                            title="Live Map"
                            size={1}
                            color="Grey"
                        />
                    }
                    checkedIcon={
                        <Icon
                            path={mdiMapMarker}
                            title="Live Map"
                            size={1}
                            color="DodgerBlue"
                        />
                    }
                    name="markerVisible"
                    checked={markerVisible}
                    onChange={toggleMarkerVisible}
                />

*/